import queryString from 'query-string';
/**
 * Create an image URL for ImageProcessor
 * @param image The image model
 * @param imageParams The image parameters
 * @returns The image URL
 */
export function imageUrl(image, imageParams) {
    if (!image) {
        return '';
    }
    const params = {
        rxy: image.focalPoint ? `${image.focalPoint.top},${image.focalPoint.left}` : undefined,
        rmode: 'crop',
        ...imageParams,
    };
    const paramsString = queryString.stringify(params);
    // Imagesharp doesn't support heightratio parameter. Convert to height parameter for compatibility.
    if (imageParams.heightratio !== undefined && imageParams.width !== undefined) {
        params.height = imageParams.width * imageParams.heightratio;
    }
    return `${image.src}${paramsString ? `?${queryString.stringify(params)}` : ''}`;
}
